import React, { useState, useEffect } from 'react';
import { values } from './constants/AllValues';
import { documentMask, cepMask, phoneMask } from './utils/mask';
import InputText from './components/InputText';
import Row from './components/Row';
import CheckBoxList from './components/CheckBoxList';
import DropDownList from './components/DropDownList';
import InputTextButton from './components/InputTextButton';
import ListItem from './DataTransferObjects/ListItem';

import api from './services/api';
import {
  CidadeResult,
  TipoLogradouroResult,
  MapperTipoLogradouroListItem,
  MapperStringListItem,
  MapperCidadeListItem,
  Sale,
} from './DataTransferObjects/Dtos';
import { getTiposLogradouro } from './services/TipoLogradouroService';
import { getUfs, getCidades } from './services/CidadeService';
import { criarVenda } from './services/VendaService';
import axios, { AxiosError } from 'axios';
import { useParams } from 'react-router-dom';
import { isUnidadeAtendimentoValida } from './services/UnidadeAtendimentoService';

function App() {
  let { idPa } = useParams();

  const [document, setDocument] = useState('');

  const [name, setName] = useState('');
  const [nameFantasy, setNameFantasy] = useState('');

  const [addressCode, setAddressCode] = useState('');
  const [addressType, setAddressType] = useState(0);
  const [address, setAddress] = useState('');
  const [addressNumber, setAddressNumber] = useState('');
  const [district, setDistrict] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState(0);

  const [email, setEmail] = useState('');
  const [confirmacaoEmail, setConfirmacaoEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [typeAttendance, setTypeAttendance] = useState('');

  const [addressTypesList, setAddressTypesList] = useState([] as ListItem[]);
  const [stateList, setStateList] = useState([] as ListItem[]);
  const [cityList, setCityList] = useState([] as ListItem[]);

  const [errorMessage, setErrorMessage] = useState('');
  const [successCompra, setSuccessCompra] = useState(false);

  const [isLoading, setLoading] = useState(false);
  const [isPaValido, setIsPaValido] = useState(false);

  useEffect(() => {
    if (idPa && parseInt(idPa)) {
      isUnidadeAtendimentoValida(parseInt(idPa)).then(({ data }) => {
        setIsPaValido(data);
      });
    }

    if (isPaValido) {
      getTiposLogradouro().then((resp) => {
        const lista = resp.data as TipoLogradouroResult[];
        setAddressTypesList(MapperTipoLogradouroListItem(lista));
      });

      getUfs().then((resp) => {
        const ufs = resp.data as string[];
        setStateList(MapperStringListItem(ufs));
      });
    }
  }, [idPa, isPaValido]);

  useEffect(() => {
    if (state) {
      getCidades(state).then((resp) => {
        const cidades = resp.data as CidadeResult[];
        setCityList(MapperCidadeListItem(cidades));
      });
    }
  }, [state]);

  const handleClickBuscarCEP = (value: string) => {
    api.post('cep/public/consultar-cep', value).then((resp) => {
      if (resp && resp.data && resp.data.cep) {
        const {
          idTipoLogradouro,
          endereco,
          numero,
          bairro,
          uf,
          idCidade,
        } = resp.data;

        setAddressType(idTipoLogradouro);
        setAddress(endereco);
        setAddressNumber(numero);
        setDistrict(bairro);
        setState(uf);
        setCity(idCidade);
      } else {
        setAddressType(0);
        setAddress('');
        setAddressNumber('');
        setDistrict('');
        setState('');
        setCity(0);
        alert(`Erro ao buscar o cep ${value}`);
      }
    });
  };

  const handleClickSolicitar = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setLoading(true);
    setSuccessCompra(false);
    setErrorMessage('');

    const compra = getCompra();

    if (isOk(compra)) {
      criarVenda(compra)
        .then(({ data }) => {
          if (data) {
            setSuccessCompra(true);
            setErrorMessage(`${data.message}`);
          }
          limparState();
        })
        .catch((error: Error | AxiosError) => {
          setLoading(false);
          if (axios.isAxiosError(error)) {
            let data = error.response?.data;
            setErrorMessage(`${data.message}`);
          } else {
            setErrorMessage(
              'Erro ao enviar dados, verifique os dados informados'
            );
          }
        });
    } else {
      setLoading(false);
      setErrorMessage('Preencha os campos obrigatórios');
    }
  };

  const handleClickNovaSolicitar = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setSuccessCompra(false);
  };

  const limparState = () => {
    setLoading(false);
    setDocument('');

    setName('');
    setNameFantasy('');

    setAddressCode('');
    setAddressType(0);
    setAddress('');
    setAddressNumber('');
    setDistrict('');
    setState('');
    setCity(0);

    setEmail('');
    setConfirmacaoEmail('');
    setPhone('');

    setTypeAttendance('');
    setErrorMessage('');
  };

  const getCompra = (): Sale => {
    let idProvedor = parseInt(idPa || '0');
    return {
      idProvedor: idProvedor,
      idProduto: values.idProduto,
      idVendedor: values.idVendedor,
      tipoDocumento: 'PJ',
      documento: document,
      nome: name,
      nomeFantasia: nameFantasy,
      endereco: {
        cep: addressCode,
        idTipoLogradouro: addressType,
        endereco: address,
        numero: addressNumber,
        bairro: district,
        uf: state,
        idCidade: city,
        complemento: '',
      },
      email,
      confirmacaoEmail,
      telefone: phone,
      tipoAtendimento: typeAttendance,
    } as Sale;
  };

  const isOk = (venda: Sale): boolean => {
    if (
      venda.documento &&
      venda.tipoDocumento &&
      venda.nome &&
      venda.endereco &&
      venda.endereco.cep &&
      venda.endereco.idTipoLogradouro &&
      venda.endereco.endereco &&
      venda.endereco.numero &&
      venda.endereco.bairro &&
      venda.endereco.uf &&
      venda.endereco.idCidade &&
      venda.email &&
      venda.confirmacaoEmail &&
      venda.telefone &&
      venda.tipoAtendimento
    )
      return true;

    return false;
  };

  return (
    <div className="container">
      {isPaValido ? (
        <>
          {!successCompra && (
            <div>
              <h3>Produto</h3>
              <Row>
                <div className="col">
                  <div className="input-check">
                    <input
                      type="radio"
                      value="E-CNPJ"
                      defaultChecked
                      name="ecnpj"
                    />
                    <label htmlFor="ecnpj">Certificado e-CNPJ A1 - <strong>R$ 175,00</strong> </label>
                  </div>
                </div>
              </Row>
              <h3>Informações do Pagador</h3>
              <Row>
                <InputText
                  className="col col-2"
                  label="CNPJ"
                  mandatory={true}
                  name="document"
                  value={document}
                  changeState={(value) =>
                    setDocument(documentMask(value, 'PJ'))
                  }
                />
                <div className="col col-2"></div>
              </Row>
              <Row>
                <InputText
                  className="col"
                  label="Razão Social"
                  mandatory={true}
                  name="name"
                  value={name}
                  changeState={(value) => setName(value)}
                />
              </Row>
              <Row>
                <InputText
                  className="col"
                  label="Nome Fantasia"
                  mandatory={false}
                  name="nameFantasy"
                  value={nameFantasy}
                  changeState={(value) => setNameFantasy(value)}
                />
              </Row>
              <h3>Endereço de cobrança</h3>
              <Row>
                <InputTextButton
                  className="col-1"
                  label="CEP"
                  mandatory={true}
                  name="addressCode"
                  value={addressCode}
                  changeState={(value) => setAddressCode(cepMask(value))}
                  buttonText="Buscar"
                  buttonClick={handleClickBuscarCEP}
                />
                <DropDownList
                  className="col-1"
                  label="Tipo Logradouro"
                  mandatory={true}
                  value={addressType.toString()}
                  name="addressType"
                  hasDefaultOption={true}
                  changeState={(value) => setAddressType(parseInt(value))}
                  data={addressTypesList}
                />
              </Row>
              <Row>
                <InputText
                  className="col-2"
                  label="Endereço"
                  mandatory={true}
                  name="address"
                  value={address}
                  changeState={(value) => setAddress(value)}
                />
                <InputText
                  className="col-1"
                  label="Número"
                  mandatory={true}
                  name="addressNumber"
                  value={addressNumber}
                  changeState={(value) => setAddressNumber(value)}
                />
              </Row>
              <Row>
                <InputText
                  className="col"
                  label="Bairro"
                  mandatory={true}
                  name="district"
                  value={district}
                  changeState={(value) => setDistrict(value)}
                />
              </Row>
              <Row>
                <DropDownList
                  className="col-1"
                  label="UF"
                  mandatory={true}
                  value={state}
                  name="UF"
                  hasDefaultOption={true}
                  changeState={(value) => setState(value)}
                  data={stateList}
                />
                <DropDownList
                  className="col-2"
                  label="Cidade"
                  mandatory={true}
                  value={city.toString()}
                  name="city"
                  hasDefaultOption={true}
                  changeState={(value) => setCity(parseInt(value))}
                  data={cityList}
                />
              </Row>
              <h3>Contatos</h3>
              <Row>
                <InputText
                  className="col"
                  label="E-mail"
                  mandatory={true}
                  name="email"
                  value={email}
                  changeState={(value) => setEmail(value)}
                />
              </Row>
              <Row>
                <InputText
                  className="col"
                  label="Confirmação de E-mail"
                  mandatory={true}
                  name="confirmacaoEmail"
                  value={confirmacaoEmail}
                  changeState={(value) => setConfirmacaoEmail(value)}
                />
              </Row>
              <Row>
                <InputText
                  className="col"
                  label="Telefone: DD + Número"
                  mandatory={true}
                  name="phone"
                  value={phone}
                  changeState={(value) => setPhone(phoneMask(value))}
                />
              </Row>
              <h3>Como gostaria de fazer a ativação?</h3>
              <Row>
                <CheckBoxList
                  groupName="ativacao"
                  data={[
                    {
                      text: 'Videoconferência',
                      value: 'video',
                      checked: typeAttendance === 'video',
                    },
                    {
                      text: 'Presencial',
                      value: 'presencial',
                      checked: typeAttendance === 'presencial',
                    },
                  ]}
                  changeState={(value) => setTypeAttendance(value)}
                />
              </Row>
              {typeAttendance === 'video' && (
                <div className="message-tipo-atendimento">
                  Para emissão por videoconferência é necessário possuir CNH ou ter biometria digital coletada na última emissão de seu certificado digital. 
                  Para verificar se sua biometria já foi coletada anteriormente clique em 
                  <a
                    href={values.urlVideoConferencia}
                    target="_blank" rel="noreferrer"
                  >&nbsp;CONSULTAR
                  </a>.
                  <br />
                  Caso não tenha biometria cadastrada, selecione a opção de atendimento presencial e verifique uma unidade mais perto de você antes de finalizar a compra.
                </div>
              )}

              {typeAttendance === 'presencial' && (
                <div className="message-tipo-atendimento">
                  Para emissão presencial, consulte a unidade mais próxima antes de confirmar a compra.
                  <br />
                  <a
                    href={values.urlLocaisAtendimento}
                    target="_blank" rel="noreferrer"
                  >
                    CLIQUE AQUI PARA CONSULTAR
                  </a>
                </div>
              )}
              {errorMessage && <div className="error">* {errorMessage}</div>}
              <button
                onClick={handleClickSolicitar}
                disabled={isLoading || !isOk(getCompra())}
              >
                {' '}
                Solicitar
              </button>
            </div>
          )}
          {successCompra && (
            <div className="eng-success">
              <div className="success">
                <h2>Compra realizada com sucesso</h2>
                confira o seu e-mail com o link de pagamento
              </div>

              <button onClick={handleClickNovaSolicitar}>
                {' '}
                Nova Solicitação
              </button>
            </div>
          )}{' '}
        </>
      ) : (
        <div className="error">
          É necessário informar o polo da compra para abrir o formulário <br />
          Informe no seguinte padrão /idPoloPa
        </div>
      )}
    </div>
  );
}

export default App;
